<div class="row login-box">
    <div class="col-12 col-sm-10 col-lg-7 login-backgroud">
        <div class="row" style="height: 85%;">
            <div class="col-md-6"></div>

            <div class="col-12 col-md-6 login-form align-self-center">
                <div class="row">
                    <div class="col-12 text-center">
                        <b>
              <h2 class="font-cust-blue title">AGENT BANK</h2>
            </b>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12">
                        <div class="input-group">
                            <label for="username"><span class="fa fa-lg fa-user font-cust-blue"></span></label>
                            <input type="text" class="form-control ml-3" name="Username" id="username" placeholder="Username">
                            <small></small>
                        </div>
                    </div>
                </div>
                <div class="row mt-3 mb-3">
                    <div class="col-12">
                        <div class="input-group">
                            <label for="password"><span class="fa fa-lg fa-key font-cust-blue"></span></label>
                            <input type="password" class="form-control ml-3" name="Password" id="password" placeholder="Password">
                            <small></small>
                        </div>
                    </div>
                </div>
                <div class="row mt-3 text-center">
                    <div class="col-12">
                        <canvas id="canvas"></canvas>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-1"></div>
                    <div class="col-11">
                        <input name="code" class="form-control">
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 text-center">
                        <button class="btn btn-success" (click)="Login()">Login</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="modal fade" id="dlgChngPwd" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" id="btnCloseDlg" data-dismiss="modal">X</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12" style="display: flex; justify-content: center;">
                                <h3>กรุณาเปลี่ยนรหัสผ่านใหม่</h3>
                            </div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-4">รหัสผ่านใหม่</div>
                            <div class="col-8"><input type="password" id="txtNewPwd" class="txt"></div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-4">ยืนยันรหัสผ่าน</div>
                            <div class="col-8">
                                <input type="password" id="txtConfirmPwd" class="txt">
                                <span style="color: red;" id="lblPwdError"></span>
                            </div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-12">1. ตั้งรหัสผ่านใหม่ เป็นภาษาอังกฤษความยาว 8 ถึง 16 ตัวอักษร</div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-12">2. โดยจะต้องมีอักษรตัวใหญ่ (A-Z) และตัวเล็ก (a-z)</div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-12">3. ตัวเลข (0-9) และอักขระพิเศษ (!,@,...) ผสมกัน</div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-12" style="display: flex; justify-content: center;">
                                <button class="btn btn-success" (click)="SavePassword()">บันทึก</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


// WEBPACK FOOTER //
// ./src/app/account/login/login.component.html